import { useEffect, useState, useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { Box, SxProps } from '@mui/material';
import OrderBySelect, { IOrderBySelectReturn } from 'src/views/uiflow/orders/components/orderbyselect';
import React from 'react';

function getColumn(columnNo: string): string {
  switch (columnNo) {
    case '1':
      return 'collectionDateTime';

    case '2':
      return 'orderDate';

    default:
      return 'deliveryDateTime';
  }
}

interface DashboardOrderBySelectProps {
  widgetName: string;
  onChange?: (value: string) => void;
  sx?: SxProps;
  className?: string;
}

const DashboardOrderBySelect = ({ widgetName, onChange, sx = {}, className }: DashboardOrderBySelectProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filterColumn, setFilterColumn] = useState<string>('orderDate');

  const auth = useAuth();
  const user = auth.user;
  const loggedInUserId = user?.profile.tenantUserId as string;

  /**
   * Handle option selection change.
   *
   * - Saves new selection to local storage.
   * - Sets the filter column to the new selection.
   * - Calls onChange with the new selection.
   *
   * @param column IOrderBySelectReturn
   * @returns void
   */
  const handleOrderBySelectChange = (
    column: IOrderBySelectReturn,
    event: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    event.stopPropagation();

    localStorage.setItem(`ordercolumn-dashboard-${loggedInUserId}`, JSON.stringify(column.orderByIndex));
    setFilterColumn(column.orderByColumn);

    if (typeof onChange === 'function') {
      onChange(column.orderByColumn);
    }
  };

  /**
   * Handle populating initial value.
   */
  const handleMount = useCallback(() => {
    const column = getColumn(
      localStorage.getItem(`ordercolumn-dashboard-${loggedInUserId}`)?.replace(/["]/g, '') ?? '0'
    );

    setFilterColumn(column);

    if (typeof onChange === 'function') {
      onChange(column);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUserId, widgetName]);

  useEffect(() => {
    handleMount();
  }, [handleMount]);

  return (
    <Box sx={{ ...sx }} className={className ?? ''}>
      <OrderBySelect
        hideDelete={true}
        selectedValue={localStorage.getItem(`ordercolumn-dashboard-${loggedInUserId}`)?.replace(/["]/g, '') ?? '0'}
        onChange={handleOrderBySelectChange}
      />
    </Box>
  );
};

export default React.memo(DashboardOrderBySelect);
